import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiSwitch: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    padding: '0 8px',
                    margin: '0 -8px',
                    height: '32px',
                    width: 'unset',
                    alignItems: 'center',
                    position: 'relative',
                    transition: 'background .3s cublic-bezer(.22, .61, .36, 1)',
                },
                switchBase: {
                    padding: 'unset !important',
                    top: 'unset',
                    left: '8px',
                    '&.Mui-checked': {
                        transform: 'translateX(0)',
                        left: 'calc(100% - 32px)',
                        color: designTokens.color.shade.white.value,
                        '& + .MuiSwitch-track': {
                            backgroundColor: designTokens.color.blue.default.value,
                            opacity: 1,
                        },
                    },
                    '&.Mui-disabled&.Mui-checked': {
                        color: designTokens.color.shade.white.value,
                        '& + .MuiSwitch-track': {
                            opacity: 0.3,
                        },
                    },
                },
                sizeSmall: {
                    '.MuiSwitch-thumb': {
                        height: '10px',
                        width: '10px',
                    },
                    '.MuiSwitch-track': {
                        height: '16px',
                        width: '32px',
                    },
                    '.Mui-checked': {
                        transform: 'translateX(0)',
                        left: 'calc(100% - 40px)',
                    },
                },
                thumb: {
                    height: theme.spacing(2.25),
                    width: theme.spacing(2.25),
                    margin: '3px',
                },
                track: {
                    height: theme.spacing(3),
                    width: theme.spacing(6),
                    borderRadius: '999px',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=toggleTheme.js.map